import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=594b5b84&scoped=true"
import script from "./bankCard.vue?vue&type=script&lang=js"
export * from "./bankCard.vue?vue&type=script&lang=js"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=594b5b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b5b84",
  null
  
)

export default component.exports